import axios from "axios";

// Distinguish "unset" (plain `yarn start`, no .env — fall back to local .NET API)
// from "explicitly set to empty string" (production Docker build — same-origin /api).
// A plain `||` fallback would wrongly treat the empty-string prod case as unset.
const envBackendUrl = process.env.REACT_APP_BACKEND_URL;
const BACKEND_URL = envBackendUrl !== undefined ? envBackendUrl : "http://localhost:5166";
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = "voocly_admin_token";

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: false,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (resp) => resp,
  (error) => {
    if (error.response?.status === 401) {
      // Token invalid — clear and let route guards redirect.
      localStorage.removeItem(TOKEN_KEY);
      window.dispatchEvent(new Event("voocly-admin-unauthorized"));
    }
    return Promise.reject(error);
  }
);

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
